import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
//primereact
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Skeleton } from "primereact/skeleton";
import { RadioButton } from "primereact/radiobutton";
import { Accordion, AccordionTab } from "primereact/accordion";
//components
import NumberInput from "../../../../components/input/NumberInput";
import Switch from "../../../../components/input/Switch";
//services
import { postEntry } from "../../../../services/Settings/Simulator/postEntry";

export default function Entry({ info, loading, refetch }) {
  const { id } = useParams();
  const [checked, setChecked] = useState(false);
  const [radioButton, setRadioButton] = useState("percent");
  const [loadingButton, setLoadingButton] = useState(false);
  const [activeIndexAccordion, setActiveIndexAccordion] = useState(0);

  const form = useForm();
  const errors = form.formState.errors;
  const formDown = useForm();
  const errorsDown = formDown.formState.errors;

  const onSubmit = async (data) => {
    //  console.log(data);
    //    console.log(radioButton);
    setLoadingButton(true);
    if (data.rate_entry === null) {
      data.rate_entry = 0;
    }
    const notification = toast.loading("Por favor aguarde...");
    data.enterprise_id = parseInt(id);
    data.type_entry = radioButton === "percent" ? 1 : 2;
    const response = await postEntry(data);
    if (response.success) {
      refetch().then(() => {
        toast.update(notification, {
          render: "Informação salva com sucesso",
          autoClose: 1000,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
        setLoadingButton(false);
        setActiveIndexAccordion(1);
      });
    } else {
      toast.update(notification, {
        render: "Algo deu errado!",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
    }
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  useEffect(() => {
    if (info) {
      const defaultValues = {
        entry_value: info.entry_value,
        installments_interest_entry: info.installments_interest_entry,
      };
      const defaultValuesDown = {
        rate_entry: info.rate_entry,
        down_payment_installments: info.down_payment_installments,
      };
      setChecked(info.installments_interest_entry);
      if (info.type_entry === 2) setRadioButton("fixed");
      if (info.type_entry === 1) setRadioButton("percent");
      form.reset(defaultValues);
      formDown.reset(defaultValuesDown);
    }
  }, [info, form, formDown]);

  return (
    <>
      {loading ? (
        <>
          <div className="d-flex">
            <Skeleton width="100%" height="300px" />
          </div>
          <div className="row mt-4">
            <div className="col-md-6 d-flex justify-content-start">
              <Skeleton width="20%" height="50px" />
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              <Skeleton width="20%" height="50px" />
            </div>
          </div>
        </>
      ) : (
        <>
          <Accordion
            activeIndex={activeIndexAccordion}
            onTabChange={(e) => setActiveIndexAccordion(e.index)}
          >
            <AccordionTab
              header={
                <div className="flex align-items-center">
                  <i className="fa-solid fa-hand-holding-dollar"></i>
                  <span className="mx-2 vertical-align-middle">
                    Entrada, desconto e parcelas *
                  </span>
                </div>
              }
            >
              <form onSubmit={form.handleSubmit(onSubmit)}>
                <div className="row">
                  <div>
                    <b>
                      {" "}
                      Informe o Mínimo de Entrada necessário para Realizar a
                      Venda{" "}
                    </b>
                  </div>
                  <div className="d-flex col-md-6 justify-content-between mt-3">
                    <div className="d-flex">
                      <RadioButton
                        inputId="percent"
                        name="percent"
                        value="percent"
                        checked={radioButton === "percent"}
                        onChange={(e) => {
                          setRadioButton(e.value);
                          form.setValue("entry_value", 0);
                        }}
                      />
                      <label htmlFor="ingredient1" className="mx-2">
                        Taxa Percentual
                      </label>
                      <div className="mx-2">
                        <Tooltip target=".custom-target-icon" />
                        <i
                          className="custom-target-icon pi pi-info-circle p-text-secondary"
                          data-pr-tooltip="Você pode utilizar uma taxa percentual para definir o mínimo de entrada. Ex: 10% de entrada"
                          style={{ cursor: "pointer" }}
                        ></i>
                      </div>
                    </div>
                    <div className="d-flex">
                      <RadioButton
                        inputId="fixed"
                        name="fixed"
                        value="fixed"
                        onChange={(e) => {
                          setRadioButton(e.value);
                          form.setValue("entry_value", 0);
                        }}
                        checked={radioButton === "fixed"}
                      />
                      <label htmlFor="ingredient1" className="mx-2">
                        Valor Fixo
                      </label>
                      <div className="mx-2">
                        <Tooltip target=".custom-target-icon" />
                        <i
                          className="custom-target-icon pi pi-info-circle p-text-secondary"
                          data-pr-tooltip="Você pode utilizar um valor fixo de entrada para definir o mínimo de entrada. Ex: R$ 5.000,00 em qualquer venda"
                          style={{ cursor: "pointer" }}
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mt-4">
                      <NumberInput
                        suffix={radioButton === "percent" ? "%" : ""}
                        placeholder={radioButton === "percent" ? "0%" : "0"}
                        max={radioButton === "percent" ? 100 : Infinity}
                        mode={radioButton === "fixed" ? "currency" : "decimal"}
                        currency={radioButton === "fixed" ? "BRL" : undefined}
                        locale={radioButton === "fixed" ? "pt-BR" : undefined}
                        useGrouping={radioButton === "fixed"}
                        minFractionDigits={2}
                        name="entry_value"
                        control={form.control}
                        label={
                          radioButton === "percent"
                            ? "% Min. Entrada"
                            : "R$ Valor Fixo Entrada"
                        }
                        getFormErrorMessage={getFormErrorMessage}
                      />
                    </div>
                    <div className="col-md-4 text-center">
                      <div className="d-flex justify-content-center">
                        <p>Parcelas + Juros ?</p>
                        <div className="mx-2">
                          <Tooltip target=".custom-target-icon" />
                          <i
                            className="custom-target-icon pi pi-info-circle p-text-secondary"
                            data-pr-tooltip="Caso esta opção esteja habilitada, o valor da parcelas de entrada será exibido com os juros cadastrados. Se desabilitado, o valor da parcela será exibido sem juros, porém os juros serão amortizados no saldo devedor"
                            style={{ cursor: "pointer" }}
                          ></i>
                        </div>
                      </div>
                      <Switch
                        name="installments_interest_entry"
                        control={form.control}
                        checked={checked}
                        getFormErrorMessage={getFormErrorMessage}
                      />
                    </div>
                    <div className="col-md-2">
                      <div className="d-flex justify-content-center mt-3">
                        <Button
                          rounded
                          type="submit"
                          iconPos="right"
                          label="Salvar"
                          loading={loadingButton}
                          icon="fa-solid fa-check"
                          className="p-inputtext-sm m-auto"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </AccordionTab>
            <AccordionTab
              header={
                <div className="flex align-items-center">
                  <i className="fa-solid fa-percent"></i>
                  <span className="mx-2 vertical-align-middle">
                    Taxas na entrada *
                  </span>
                </div>
              }
            >
              <form onSubmit={formDown.handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-md-5 mt-2">
                    <div>
                      <b> Informe a Taxa de Juros da Entrada </b>
                      <Tooltip target=".custom-target-icon" />
                      <i
                        className="custom-target-icon pi pi-info-circle p-text-secondary"
                        data-pr-tooltip="Você pode cobrar uma taxa de juros para parcelar a entrada"
                        style={{ cursor: "pointer" }}
                      ></i>
                    </div>
                    <NumberInput
                      name="rate_entry"
                      suffix="%"
                      placeholder="0%"
                      max={100}
                      minFractionDigits={2}
                      control={formDown.control}
                      errors={errorsDown}
                      label=" Taxa de Juros de Entrada"
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                  <div className="col-md-5 mt-2">
                    <div>
                      <b> Informe o Número Máximo de Parcelas de Entrada: * </b>
                      <Tooltip target=".custom-target-icon" />
                      <i
                        className="custom-target-icon pi pi-info-circle p-text-secondary"
                        data-pr-tooltip="Você pode definir um número máximo de parcelas para dividir o valor correspondente a entrada"
                        style={{ cursor: "pointer" }}
                      ></i>
                    </div>
                    <NumberInput
                      name="down_payment_installments"
                      placeholder="0"
                      max={100}
                      control={formDown.control}
                      errors={errorsDown}
                      label="Máximo de Parcelas de Entrada"
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                  <div className="col-xl-2 pt-2">
                    <div className="d-flex justify-content-center mt-5">
                      <Button
                        rounded
                        type="submit"
                        iconPos="right"
                        label="Salvar"
                        loading={loadingButton}
                        icon="fa-solid fa-check"
                        className="p-inputtext-sm m-auto"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </AccordionTab>
          </Accordion>
        </>
      )}
    </>
  );
}
